import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

export function getCustomerUserMeterInfo(myPage) {
  return request({
    url: cmsServerContext + '/Meter/getCustomerUserMeterInfo',
    method: 'post',
    data: myPage
  })
}
